export const channels = [
  {
    id: '1',
    name: 'Canal Independiente 1',
    country: 'México',
    description: 'Canal de noticias locales y entretenimiento familiar con programación 24/7',
    poster: 'https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=400&h=600&fit=crop',
    streamUrl: 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
    category: 'Noticias',
    language: 'Español'
  },
  {
    id: '2',
    name: 'TV Cultural',
    country: 'Argentina',
    description: 'Programación cultural, documentales y contenido educativo de alta calidad',
    poster: 'https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?w=400&h=600&fit=crop',
    streamUrl: 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
    category: 'Cultural',
    language: 'Español'
  },
  {
    id: '3',
    name: 'Sports Network',
    country: 'Colombia',
    description: 'Deportes locales, fútbol amateur y eventos deportivos comunitarios',
    poster: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=400&h=600&fit=crop',
    streamUrl: 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
    category: 'Deportes',
    language: 'Español'
  },
  {
    id: '4',
    name: 'Music TV',
    country: 'España',
    description: 'Videos musicales, conciertos en vivo y programas de música independiente',
    poster: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=600&fit=crop',
    streamUrl: 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
    category: 'Música',
    language: 'Español'
  },
  {
    id: '5',
    name: 'Kids Channel',
    country: 'Chile',
    description: 'Programación infantil educativa y entretenimiento para toda la familia',
    poster: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=400&h=600&fit=crop',
    streamUrl: 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
    category: 'Infantil',
    language: 'Español'
  },
  {
    id: '6',
    name: 'Tech Today',
    country: 'Perú',
    description: 'Noticias de tecnología, reviews de gadgets y tendencias digitales',
    poster: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=400&h=600&fit=crop',
    streamUrl: 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
    category: 'Tecnología',
    language: 'Español'
  }
];

export const categories = [
  'Todos',
  'Noticias',
  'Cultural',
  'Deportes',
  'Música',
  'Infantil',
  'Tecnología',
  'Religión'
];
